import { STATUS_LABEL } from "@/components/t4r/learners/LearnerTable";

const cell = (v) => {
  const s = String(v ?? "");
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export const exportLearnersCsv = (rows, filename = "learners.csv") => {
  const head = ["Name", "Email", "Status", "Courses", "Progress %", "Lessons completed", "Lessons total", "Last active", "Invited", "Activated", "Invite link"];
  const body = rows.map((l) => [l.name, l.email, STATUS_LABEL[l.status] || l.status, l.course_titles.join("; "), l.course_pct ?? l.progress_pct,
    l.lessons_done, l.lessons_total, l.last_active_at, l.invited_at, l.activated_at, l.invite_url || ""]);
  const csv = [head, ...body].map((r) => r.map(cell).join(",")).join("\r\n");
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8" }));
  a.download = filename; a.click();
};
